import { FC } from 'react';
import { theme } from 'antd';
import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const CompAirAssureCompleteIcon: FC<{
  width?: number;
  height?: number;
  [x: string]: unknown;
}> = ({ width = 129, height = 32, ...rest }) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };

  const primaryColor = token.CompairAssure.colorPrimary;
  const secondaryColor = token.CompairAssure.colorSecondary;

  return (
    <svg width={width} height={height} viewBox="0 0 129 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M69.6091 12.6047C68.8507 12.322 68.0776 12.0101 67.2155 12.0101C64.9409 12.0101 63.4839 13.5412 63.4839 15.8607C63.4839 18.0014 64.9409 19.5771 67.3046 19.5771C68.0776 19.5771 68.8506 19.2203 69.6386 18.9824L69.817 20.6178C68.9104 20.856 68.048 21.168 67.1262 21.168C63.4689 21.168 61.3877 19.0272 61.3877 15.8607C61.3877 12.6791 63.5433 10.4192 67.0222 10.4192C68.0627 10.4192 68.9696 10.7763 69.7426 10.9693L69.6091 12.6047Z"
        fill="#0E88D3"
      />
      <path
        d="M71.6595 15.7713C71.6595 18.1502 72.8192 19.6069 74.4696 19.6069C76.1197 19.6069 77.2944 18.1353 77.2944 15.7713C77.2944 13.4077 76.1197 11.9506 74.4696 11.9506C72.8192 11.9506 71.6595 13.4077 71.6595 15.7713ZM79.3607 15.8012C79.3607 19.1757 77.4877 21.168 74.4696 21.168C71.4518 21.168 69.5932 19.1757 69.5932 15.8012C69.5932 12.4263 71.4518 10.4192 74.4696 10.4192C77.4877 10.4192 79.3607 12.4413 79.3607 15.8012Z"
        fill="#0E88D3"
      />
      <path
        d="M82.9429 10.6424L85.4407 17.8081C85.5593 18.1648 85.6783 18.7299 85.7378 19.5179C85.7826 18.804 85.8716 18.2243 86.0204 17.8081L88.6073 10.6424H91.655V20.9597H89.7073V13.3333C89.7073 12.7386 89.7518 12.1141 89.8408 11.4898C89.6478 12.3071 89.499 12.813 89.4398 12.9911L86.5556 20.9597H84.7418L81.9171 13.0655C81.7685 12.6346 81.6347 12.0994 81.5307 11.4898C81.6051 12.4562 81.6496 13.0804 81.6496 13.3479V20.9597H79.8507V10.6424H82.9429Z"
        fill="#0E88D3"
      />
      <path
        d="M94.627 15.578H95.4595C96.7976 15.578 97.5112 14.9537 97.5112 13.8535C97.5112 12.7386 96.8275 12.0994 95.5784 12.0994H94.627V15.578ZM95.6528 10.6424C98.2992 10.6424 99.5925 11.6533 99.5925 13.8535C99.5925 15.8308 98.2248 17.035 95.7269 17.035H94.627V20.9597H92.5902V10.6424H95.6528Z"
        fill="#0E88D3"
      />
      <path d="M102.067 10.6424V19.3837H106.2V20.9597H100.031V10.6424H102.067Z" fill="#0E88D3" />
      <path
        d="M113.083 10.6424V12.1287H108.817V14.8644H112.86V16.3809H108.817V19.3987H113.232V20.9597H106.78V10.6424H113.083Z"
        fill="#0E88D3"
      />
      <path d="M121.021 10.6424V12.233H118.271V20.9597H116.234V12.233H113.514V10.6424H121.021Z" fill="#0E88D3" />
      <path
        d="M127.875 10.6424V12.1287H123.608V14.8644H127.652V16.3809H123.608V19.3987H128.023V20.9597H121.571V10.6424H127.875Z"
        fill="#0E88D3"
      />
      <path
        d="M24.2045 23.244C21.9872 26.815 18.831 29.6056 14.5858 31.7542L14.1003 32L13.6145 31.7554C9.10161 29.4866 5.81611 26.4576 3.57108 22.4948C0.834175 17.6641 -0.310294 11.5905 0.0715005 3.92712L0.112359 3.1062L14.096 0L28.0776 3.10589L28.1203 3.92468C28.1968 5.39239 28.2167 6.80247 28.1804 8.15522C28.1721 8.15522 26.0366 8.15491 26.0158 8.15491C26.0482 7.10589 26.0454 6.00625 26.0027 4.85446L14.096 2.20965L2.19089 4.85385C1.62978 20.8722 8.54813 26.6698 14.0973 29.579C16.5884 28.265 19.3567 26.367 21.5984 23.2437L24.2045 23.244Z"
        fill="#0E88D3"
      />
      <path
        d="M14.0966 4.00371L3.83119 6.28381C3.64029 10.1176 3.96231 13.3159 4.66613 16C6.28815 22.1862 9.94722 25.6263 14.0991 27.7134V4.00401L14.0966 4.00371Z"
        fill={primaryColor}
      />
      <path
        d="M27.2756 12.935C26.3818 12.4681 25.4883 12.2241 24.6149 12.2241C23.6403 12.2241 23.1326 12.5697 23.1326 13.1585C23.1326 13.9099 23.8837 14.174 25.0211 14.6814C26.9508 15.5347 27.9254 16.3065 27.9254 17.8703C27.9254 19.7792 26.3211 21.0588 23.5589 21.0588C22.8173 21.0588 22.2961 20.9572 21.6847 20.7349L20.8888 18.6714C21.8838 19.159 22.5434 19.2309 23.5388 19.2309C24.6149 19.2309 25.1836 18.8452 25.1836 18.2359C25.1836 17.4641 24.3914 17.0783 23.0917 16.4282C21.4468 15.6158 20.492 14.9254 20.492 13.4628C20.492 11.7368 22.0561 10.3963 24.6558 10.3963C25.5493 10.3963 26.5038 10.6808 27.4787 10.9851L27.2756 12.935Z"
        fill={primaryColor}
      />
      <path
        d="M34.4723 12.935C33.5788 12.4681 32.685 12.2241 31.8117 12.2241C30.8371 12.2241 30.3293 12.5697 30.3293 13.1585C30.3293 13.9099 31.0807 14.174 32.2182 14.6814C34.1476 15.5347 35.1222 16.3065 35.1222 17.8703C35.1222 19.7792 33.5179 21.0588 30.7559 21.0588C29.6185 21.0588 28.5216 20.8761 27.5671 20.5306L27.7092 18.4997C28.7046 18.9873 29.7405 19.2309 30.7355 19.2309C31.8117 19.2309 32.3804 18.8452 32.3804 18.2359C32.3804 17.4641 31.5885 17.0783 30.2885 16.4282C28.6436 15.6158 27.6888 14.9254 27.6888 13.4628C27.6888 11.7368 29.2529 10.3963 31.8525 10.3963C32.746 10.3963 33.7005 10.6808 34.6754 10.9851L34.4723 12.935Z"
        fill={primaryColor}
      />
      <path
        d="M37.95 10.6604V16.1236C37.95 18.0124 38.5797 18.9059 39.9812 18.9059C41.5246 18.9059 42.3979 17.6672 42.3979 15.2505V10.6604H45.0586V20.9573H42.6416V18.9873C41.8698 20.3886 40.6106 21.1198 38.9859 21.1198C36.5893 21.1198 35.2896 19.6167 35.2896 16.6923V10.6604H37.95Z"
        fill={primaryColor}
      />
      <path
        d="M51.9556 12.8945C51.6507 12.7929 51.3464 12.752 51.0417 12.752C49.3151 12.752 48.3609 13.9099 48.3609 16.1443V20.9573H45.7204V10.6604H48.0965V12.7118C48.7467 11.1883 49.7621 10.4165 51.1429 10.4165C51.407 10.4165 51.7117 10.4573 52.0572 10.5183L51.9556 12.8945Z"
        fill={primaryColor}
      />
      <path
        d="M56.0447 12.1226C54.7041 12.1226 53.7496 13.118 53.5465 14.8845H58.4004C58.2583 13.118 57.3648 12.1226 56.0447 12.1226ZM60.7973 16.5297H53.5465C53.6886 18.256 54.9481 19.3325 56.918 19.3325C57.9741 19.3325 58.9896 19.0888 59.944 18.5811V20.6121C58.9896 20.9978 57.832 21.2213 56.4509 21.2213C53.0184 21.2213 50.9673 19.1291 50.9673 15.6362C50.9673 12.5087 53.0388 10.3963 56.0651 10.3963C59.0505 10.3963 60.7973 12.3461 60.7973 15.6972V16.5297Z"
        fill={primaryColor}
      />
      <path
        d="M11.7385 15.5551H16.3691L14.0942 9.21862L11.7385 15.5551ZM15.8208 6.86259L21.2639 20.9573H18.2781L17.1001 17.6266H10.9667L9.74811 20.9573H6.9859L12.4698 6.86259H15.8208Z"
        fill={primaryColor}
      />
      <path
        d="M11.7361 15.5551H14.0899L14.0921 9.21862L11.7361 15.5551ZM14.0899 17.6266H10.9645L9.74597 20.9573H6.98375L12.4673 6.86259H14.0899"
        fill={secondaryColor}
      />
    </svg>
  );
};

export default CompAirAssureCompleteIcon;
